import PropTypes from 'prop-types';
export default PropTypes.shape({
    prvKeyPem: PropTypes.string,
    pubKeyPem: PropTypes.string
});
